
// components
import './components/carousel';
import './components/cards';
import './components/similarproducts';
import scrollbarWidth from './components/scroll-bar-width';
import activateTextToSpeech from './components/text-to-speech';
import microModal from './components/micro-modal';
import collapsedContent from './components/collapsable-content';
import runOnUserInteraction from './utilities/run-on-interaction';
import medicareBanner from './components/medicare-banner';

const userInteractionScripts = () => {
    scrollbarWidth();
    activateTextToSpeech();
    microModal();
    collapsedContent();
    medicareBanner();
}

runOnUserInteraction(userInteractionScripts);
